<template>
  <b-form>
    <b-card class="border0" body-class="grpHd anal">
      <video height="100%" width="100%" autoplay="autoplay" controls>
        <source :src="videoSrc" type="video/mp4" />
        브라우저가 video 태그를 지원하지 않습니다.
      </video>
    </b-card>
    <div class="btnGrp">
      <div class="jcse">
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </b-form>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["getUserId", "getAlertOptions", "getConfirmOptions"]),
  },
  data() {
    return {
      videoSrc: null,
    };
  },
  props: {
    videoFilePath: String,
  },
  created() {
    this.videoSrc = this.videoFilePath;
  },
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    beforeMount() {},
    mounted() {},
    destroyed() {},
    closeModal() {
      this.$bvModal.hide("scenePhotoVideoModal");
    },
  },
};
</script>

<style lang="scss">
#scenePhotoVideoModal .modal-dialog {
  max-width: 950px;
  & .modal-content {
    & .card {
      padding: 0 30px 30px;
      & .card-body {
        border: 1px solid #7367f0;
        border-radius: 8px;
        & .row .col {
          & label {
            display: flex;
            align-items: center;
            height: 100%;
            padding-bottom: 1px;
            width: auto;
            margin: 0 15px;
            &.head {
              width: 210px;
              margin: 0 10px 0 0;
            }
          }
          & input,
          & select {
            width: 170px;
          }
        }
        &.grpHd {
          &::before {
            display: block;
            position: absolute;
            top: -15px;
            left: 50px;
            font-size: 16px;
            font-weight: 600;
            border: 1px solid #7367f0;
            border-radius: 10px;
            color: #b4b7bd;
            background: #283046;
            padding: 1px 10px 3px;
            letter-spacing: 1px;
          }
        }
      }
      &:first-child {
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/scene-photo/ScenePhotoVideoModal.vue